// extracted by mini-css-extract-plugin
export var blogBlock = "lastNews-module--blog-block--1b21f";
export var blogLink = "lastNews-module--blog-link--d6371";
export var blogTitle = "lastNews-module--blog-title--5eaac";
export var sidebar = "lastNews-module--sidebar--9b8e6";